<template>
  <div>
    <SeedJung_Header></SeedJung_Header>
    <div class="counselor-intro">
      <div class="container">
        <div class="counselor-profile">
          <div class="row">
            <div class="col-md-12">
              <h2 class="name text-center">대표 상담사 염성찬</h2>
              <div class="image-gallery-container">
                <div class="image-gallery">
                  <div class="image-item">
                    <img :src="require('@/assets/channy/skinny3.jpg')" alt="마른 체형 2" />
                    <p class="image-caption">Before</p>
                  </div>
                  <div class="image-item">
                    <!-- <img src="assets/channy/skinny4.jpg" alt="벌크업 2" /> -->
                    <img :src="require('@/assets/channy/skinny4.jpg')" alt="벌크업 2" />
                    <p class="image-caption">After (8개월 소요)</p>
                  </div>
                  <div class="image-item">
                    <!-- <img src="assets/channy/seedjung_best_3.jpg" alt="현재 모습" /> -->
                    <img :src="require('@/assets/channy/seedjung_best_5.jpg')" alt="현재 모습" />
                    <p class="image-caption">현재</p>
                  </div>
                </div>
                <div class="scroll-progress-bar">
                  <div class="progress"></div>
                </div>
              </div>
              <div class="profile-description text-center">
                <p class="impact-statement">
                  긴말하지 않겠습니다. 누구든지 할 수 있습니다. <br/> 신호 위반 차량에 맨몸으로 치이는 교통사고를 당하며, 3년간의 재활로 잘 먹지못해 21키로가 빠졌었습니다. <br />
                  위 사진은 재활을 마치고, 1년 6개월 동안 홀로 싸워 만든 몸의 결과 입니다.
                  평범한 학생, 직장인들이 짬내서 운동하고 잘 챙겨먹기란 쉬운게 아닙니다. 저 또한 학생이었고 지금은 9 by 6 회사를 다니는 평범한 직장인 입니다. <br />
                  그래서 더 잘 이해합니다. 
                  개인화된 식단과 상황에 맞는 운동법. 더 나아가 플랜 B도 있으면 좋겠지요. 지금 무언가 도전하거나 실천하기 힘들다 할지라도 괜찮습니다. 
                  <br/><br/> 지금의 어려운 상황 때문에 실천을 못하는 것과 방법도 모르는것은 분명한 차이가 있습니다. 
                  <br/>
                  <br/>내담자의 상황을 보고 그에 맞춰 가이드 드립니다. <br/>
                  
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeedJung_Header from './SeedJung_Header.vue'

export default {
  name: 'SeedJung_Counselor_YSC',
  components: {
    SeedJung_Header
  },
  mounted() {
    this.$nextTick(() => {
      this.initScrollProgress();
      this.setInitialScroll();
    });
  },
  methods: {
    updateProgress() {
      const gallery = document.querySelector('.image-gallery');
      const progress = document.querySelector('.progress');
      const scrollPosition = gallery.scrollLeft;
      const maxScroll = gallery.scrollWidth - gallery.clientWidth;
      const percentage = (scrollPosition / maxScroll) * 100;
      progress.style.width = `${percentage}%`;
    },
    initScrollProgress() {
      const gallery = document.querySelector('.image-gallery');
      gallery.addEventListener('scroll', this.updateProgress);
    },
    setInitialScroll() {
      const gallery = document.querySelector('.image-gallery');
      const imageWidth = gallery.querySelector('.image-item').offsetWidth;
      const gapWidth = 20; // CSS에서 설정한 gap 값
      
      // 첫 번째 이미지의 3/4 지점으로 스크롤
      gallery.scrollLeft = (imageWidth + gapWidth) * 0.3;

      // 초기 스크롤 후 프로그레스 바 업데이트
      this.$nextTick(() => {
        this.updateProgress();
      });
    }
  }
}
</script>

<style scoped>
.counselor-intro {
  margin-top: 120px;
  padding: 60px 0;
}

.name {
  font-size: 32px;
  margin-bottom: 40px;
  color: #333;
}

.image-gallery-container {
  position: relative;
  overflow: hidden;
}

.image-gallery {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  margin-bottom: 10px;  /* 스크롤바와의 간격 줄임 */
}

.image-item {
  text-align: center;
  flex: 0 0 auto;
}

.image-item img {
  width: 240px;
  height: 320px;
  object-fit: cover;
  border-radius: 15px;
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.image-item img:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(0,0,0,0.2);
}

.image-caption {
  margin-top: 15px;
  font-size: 16px;
  color: #444;
  max-width: 240px;
  word-wrap: break-word;
}

.scroll-progress-bar {
  width: 100%;
  height: 4px;
  background-color: #ddd;
  position: relative;
  margin-bottom: 20px;  /* 프로필 설명과의 간격 조정 */
}

.progress {
  height: 100%;
  background-color: #333;
  position: absolute;
  transition: width 0.3s ease;
}

.profile-description {
  max-width: 800px;
  margin: 0 auto;
  margin-bottom: 150px;
}

.impact-statement {
  font-size: 20px;
  line-height: 1.8;
  color: #333;
  font-weight: 500;
}

@media (max-width: 1024px) {
  .image-item img {
    width: 200px;
    height: 280px;
  }
}

@media (max-width: 768px) {
  .counselor-intro {
    margin-top: 80px;
    padding: 30px 0;
  }

  .name {
    font-size: 24px;
    margin-bottom: 20px;
  }

  .image-gallery {
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    padding: 20px 0;
    gap: 20px;
    margin-bottom: 10px;  /* 스크롤바와의 간격 줄임 */
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
  }

  .image-gallery::-webkit-scrollbar {
    display: none;
  }

  .image-item {
    scroll-snap-align: center;
  }
  
  .image-item img {
    width: 180px;
    height: 240px;
  }
  
  .image-caption {
    font-size: 14px;
    max-width: 180px;
  }
  
  .impact-statement {
    font-size: 16px;
    line-height: 1.6;
  }
}

@media (max-width: 480px) {
  .counselor-intro {
    margin-top: 60px;
    padding: 20px 0;
  }

  .name {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .image-item img {
    width: 150px;
    height: 200px;
  }
  
  .image-caption {
    font-size: 12px;
    max-width: 150px;
  }
  
  .impact-statement {
    font-size: 14px;
  }
}
</style>